"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.theme = void 0;
const common = {
  bg: 'transparent',
  borderRadius: 100,
  height: 32,
  activeBg: 'interactive.primary.active',
  disabledBg: 'disabled.1',
  activeBorderColor: 'interactive.primary.default'
};
const primary = { ...common,
  bg: 'ui1',
  activeFontColor: 'text.3'
};
const secondary = { ...common,
  bg: 'transparent',
  activeBg: 'transparent',
  disabledBg: 'transparent',
  activeBorderColor: 'transaparent',
  activeFontColor: 'interactive.primary.default'
};
const theme = {
  primary,
  secondary
};
exports.theme = theme;
//# sourceMappingURL=DropdownButton.theme.js.map